/* loaded by smart-asset */
export default require("./library_add-24px~KucrphTZ.svg")